import React from 'react';
import Header from './Common/header';
import './css/index';

export default class Content_audio extends React.Component {
    render() {
        const { data = {}, eid } = this.props;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@iz8lz5`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div className="ant-spin-nested-loading">
                            <div className="ant-spin-container">
                                <div id="audio_play_571" style={{ width: '100%' }}>
                                    <audio src="/page/resource/userfile/video/test1120/bgvideo.mp4"
                                      controlsList="nodownload"
                                      height="27"
                                      controls
                                      autoPlay="autoplay"
                                      style={{ width: '100%' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_audio.js